import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { AuthProvider } from './contexts/AuthContext';
import CustomerWelcome from './components/CustomerWelcome';
import CustomerMenu from './components/CustomerMenu';
import CustomerFoodDetail from './components/CustomerFoodDetail';
import CustomerCart from './components/CustomerCart';
import CustomerOrders from './components/CustomerOrders';
import CustomerProfile from './components/CustomerProfile';
import CustomerAboutUs from './components/CustomerAboutUs';
import CustomerContact from './components/CustomerContact';
import CustomerPrivacyPolicy from './components/CustomerPrivacyPolicy';
import CustomerTermsOfService from './components/CustomerTermsOfService';
import CustomerEditProfile from './components/CustomerEditProfile';
import CustomerPersonalInfo from './components/CustomerPersonalInfo';
import CustomerSupport from './components/CustomerSupport';
import CustomerCheckout from './components/CustomerCheckout';
import CustomerOrderConfirmation from './components/CustomerOrderConfirmation';
import CustomerOrderTrack from './components/CustomerOrderTrack';
import CustomerLogin from './components/CustomerLogin';
import CustomerSignUp from './components/CustomerSignUp';
import CustomerForgotPassword from './components/CustomerForgotPassword';
import CustomerResetPassword from './components/CustomerResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import CountryGate from './components/CountryGate';
import './shared/styles/App.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<CustomerLogin />} />
              <Route path="/signup" element={<CustomerSignUp />} />
              <Route path="/forgot-password" element={<CustomerForgotPassword />} />
              <Route path="/reset-password" element={<CustomerResetPassword />} />
              {/* Public routes - accessible without login, but require country selection */}
              <Route path="/" element={<CountryGate><CustomerMenu /></CountryGate>} />
              <Route path="/menu" element={<CountryGate><CustomerMenu /></CountryGate>} />
              {/* Item detail: typed route supports both food and grocery */}
              <Route path="/item/:type/:id" element={<CountryGate><CustomerFoodDetail /></CountryGate>} />
              {/* Backward compatibility for old links */}
              <Route path="/food/:id" element={<CountryGate><CustomerFoodDetail /></CountryGate>} />
              <Route path="/about" element={<CountryGate><CustomerAboutUs /></CountryGate>} />
              <Route path="/contact" element={<CountryGate><CustomerContact /></CountryGate>} />
              <Route path="/privacy" element={<CountryGate><CustomerPrivacyPolicy /></CountryGate>} />
              <Route path="/terms" element={<CountryGate><CustomerTermsOfService /></CountryGate>} />
              
              {/* Cart is public - can view without login, but checkout requires login */}
              <Route path="/cart" element={<CountryGate><CustomerCart /></CountryGate>} />
              
              {/* Protected routes - require login */}
              <Route path="/orders" element={<ProtectedRoute><CountryGate><CustomerOrders /></CountryGate></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><CountryGate><CustomerProfile /></CountryGate></ProtectedRoute>} />
              <Route path="/edit-profile" element={<ProtectedRoute><CountryGate><CustomerEditProfile /></CountryGate></ProtectedRoute>} />
              <Route path="/personal-info" element={<ProtectedRoute><CountryGate><CustomerPersonalInfo /></CountryGate></ProtectedRoute>} />
              <Route path="/support" element={<ProtectedRoute><CountryGate><CustomerSupport /></CountryGate></ProtectedRoute>} />
              <Route path="/checkout" element={<ProtectedRoute><CountryGate><CustomerCheckout /></CountryGate></ProtectedRoute>} />
              <Route path="/order-confirmation" element={<ProtectedRoute><CountryGate><CustomerOrderConfirmation /></CountryGate></ProtectedRoute>} />
              <Route path="/order/:id" element={<ProtectedRoute><CountryGate><CustomerOrderTrack /></CountryGate></ProtectedRoute>} />
            </Routes>
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
